// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"EU1_TheComp__WSiuI"};